// removed by extract-text-webpack-plugin
module.exports = {"line":"src-components-StudentList----StudentList-module---line---VHls4","row":"src-components-StudentList----StudentList-module---row---OGJsh","lineBetween":"src-components-StudentList----StudentList-module---lineBetween---2iUbP","collaborator_name":"src-components-StudentList----StudentList-module---collaborator_name---381aC","collaborator_details":"src-components-StudentList----StudentList-module---collaborator_details---a8E43","graduation_date":"src-components-StudentList----StudentList-module---graduation_date---14hkp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StudentList/StudentList.module.scss
// module id = 279
// module chunks = 43343626275220 79518935032921